export default "/images/a4ae7b84d748fc463e16c7a6fb8d6f3e.avif";